
import { defineComponent, PropType } from 'vue'
import { CtClient } from '@/models/interfaces/content-type'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'

export default defineComponent({
  name: 'ClientSettings',
  components: { EditableBlockInput, EditableBlock },
  props: {
    client: {
      type: Object as PropType<CtClient>,
      required: true,
    },
  },
  emits: ['update:client'],

})
